
<template>
  <div>
      <div class="choseus-area default-padding-top">
            <div class="container">
                <!-- <h1 style="color: #29235C;"> <strong> Indicadores Previsionales: <span style="color: #5D1F4A;" id="fechaIndicador"></span></strong></h1> -->
                <div class="text-center"> <h1 style="color: #29235C;"> <strong> Indicadores Previsionales: </strong> </h1> </div>
                <div class="text-center"> <h2> <strong> <span style="color: #5D1F4A;" id="fechaIndicador"> </span> </strong> </h2> </div>
                <div class="choseus-items">
                    <div class="row">
                        <div class="col-lg-6">
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                <tr>
                                    <th colspan="2" class="text-center">Valor UF</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td class="col-lg-8"><span id="fechaUFactual">{{previred.fechaUFactual}}</span></td>
                                    <td class="col-lg-4"><span id="UFactual">{{previred.UFactual}}</span></td>
                                </tr>
                                <tr>
                                    <td class="col-lg-8"><span id="fechaUFanterior">{{previred.fechaUFanterior}}</span></td>
                                    <td class="col-lg-4"><span id="UFanterior">{{previred.UFanterior}}</span></td>
                                </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="2" class="text-center">Rentas Topes Imponibles</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Para afiliados a una AFP (<span id="RTI1">{{previred.RTI1}}</span> UF):</td>
                                        <td class="text-center"><span id="PRTI1">{{previred.PRTI1}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Para afiliados al IPS (ex INP) (<span id="RTI2">{{previred.RTI2}}</span> UF):</td>
                                        <td class="text-center"><span id="PRTI2">{{previred.PRTI2}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Para Seguro de Cesantía (<span id="RTI3">{{previred.RTI3}}</span> UF):</td>
                                        <td class="text-center"><span id="PRTI3">{{previred.PRTI3}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="2" class="text-center">Rentas Mínimas Imponibles</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Trab. Dependientes e Independientes:</td>
                                        <td class="text-center"><span id="RMI1">{{previred.RMI1}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Menores de 18 y Mayores de 65:</td>
                                        <td class="text-center"><span id="RMI2">{{previred.RMI2}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Trabajadores de Casa Particular:</td>
                                        <td class="text-center"><span id="RMI3">{{previred.RMI3}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Para fines no remuneracionales:</td>
                                        <td class="text-center"><span id="RMI4">{{previred.RMI4}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="2" class="text-center">Ahorro Previsional Voluntario (APV)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Tope Mensual (<span id="APVtopeMensual">{{previred.APVtopeMensual}}</span> UF):</td>
                                        <td class="text-center"><span id="APVtopem">{{previred.APVtopem}}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Tope Anual (<span id="APVtopeAnual">{{previred.APVtopeAnual}}</span> UF):</td>
                                        <td class="text-center"><span id="APVtopea">{{previred.APVtopea}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="2" class="text-center">Depósito Convenido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Tope Anual (<span id="DepoUF">{{previred.DepoUF}}</span> UF):</td>
                                        <td class="text-center"><span id="DepoUFpesos">{{previred.DepoUFpesos}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="3" class="text-center">Seguro de Cesantía (AFC)</th>
                                    </tr>
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Contrato</th>
                                        <th colspan="2" class="text-center">Financiamiento</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">Empleador</th>
                                        <th class="text-center">Trabajador</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Plazo Indefinido</td>
                                        <td class="text-center"><span id="PIemp">{{previred.PIemp}}</span> R.I.</td>
                                        <td class="text-center"><span id="PItra">{{previred.PItra}}</span> R.I.</td>
                                    </tr>
                                    <tr>
                                        <td>Plazo Fijo</td>
                                        <td class="text-center"><span id="PFemp">{{previred.PFemp}}</span> R.I.</td>
                                        <td class="text-center"><span id="PFtra">{{previred.PFtra}}</span> ---</td>
                                    </tr>
                                    <tr>
                                        <td>Plazo Indefinido 11 años o más</td>
                                        <td class="text-center"><span id="PInemp">{{previred.PInemp}}</span> R.I.</td>
                                        <td class="text-center"><span id="PIntra">{{previred.PIntra}}</span> ---</td>
                                    </tr>
                                    <tr>
                                        <td>Trabajador de Casa Particular</td>
                                        <td class="text-center"><span id="Tcpemp">{{previred.Tcpemp}}</span> R.I.</td>
                                        <td class="text-center"><span id="Tcptra">{{previred.Tcptra}}</span> ---</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-lg-6">
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                    <th class="text-center">Valor</th>
                                    <th class="text-center">UTM</th>
                                    <th class="text-center">UTA</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center"><span id="UTMfec">{{previred.UTMfec}}</span></td>
                                        <td class="text-center"><span id="UTM">{{previred.UTM}}</span></td>
                                        <td class="text-center"><span id="UTA">{{previred.UTA}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th rowspan="4" class="text-center align-middle">AFP</th>
                                        <th colspan="3" class="text-center">Tasa Cotización Obligatorio AFP</th>
                                    </tr>
                                    <tr>
                                        <th colspan="3" class="text-center">Tasa AFP Trabajadores</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-center">Dependientes</th>
                                        <th class="text-center">Independientes</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">Tasa AFP</th>
                                        <th class="text-center">SIS   (1)   (2)</th>
                                        <th class="text-center">Tasa AFP   (3)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center">Capital</td>
                                        <td class="text-center"><span id="DTasaAFPCa">{{previred.DTasaAFPCa}}</span></td>
                                        <td class="text-center"><span id="STasaAFPCa">{{previred.STasaAFPCa}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPCa">{{previred.ITasaAFPCa}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Cuprum</td>
                                        <td class="text-center"><span id="DTasaAFPCu">{{previred.DTasaAFPCu}}</span></td>
                                        <td class="text-center"><span id="STasaAFPCu">{{previred.STasaAFPCu}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPCu">{{previred.ITasaAFPCu}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Habitat</td>
                                        <td class="text-center"><span id="DTasaAFPH">{{previred.DTasaAFPH}}</span></td>
                                        <td class="text-center"><span id="STasaAFPH">{{previred.STasaAFPH}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPH">{{previred.ITasaAFPH}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">PlanVital</td>
                                        <td class="text-center"><span id="DTasaAFPPV">{{previred.DTasaAFPPV}}</span></td>
                                        <td class="text-center"><span id="STasaAFPPV">{{previred.STasaAFPPV}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPPV">{{previred.ITasaAFPPV}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Provida</td>
                                        <td class="text-center"><span id="DTasaAFPP">{{previred.DTasaAFPP}}</span></td>
                                        <td class="text-center"><span id="STasaAFPP">{{previred.STasaAFPP}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPP">{{previred.ITasaAFPP}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Modelo</td>
                                        <td class="text-center"><span id="DTasaAFPM">{{previred.DTasaAFPM}}</span></td>
                                        <td class="text-center"><span id="STasaAFPM">{{previred.STasaAFPM}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPM">{{previred.ITasaAFPM}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">Uno</td>
                                        <td class="text-center"><span id="DTasaAFPU">{{previred.DTasaAFPU}}</span></td>
                                        <td class="text-center"><span id="STasaAFPU">{{previred.STasaAFPU}}</span></td>
                                        <td class="text-center"><span id="ITasaAFPU">{{previred.ITasaAFPU}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th rowspan="2" class="text-center align-middle">Tramo</th>
                                        <th colspan="2" class="text-center">Asignación Familiar</th>
                                    </tr>
                                    <tr>
                                        <th class="text-center">Monto</th>
                                        <th class="text-center">Requisito de Renta</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center">1   (A)</td>
                                        <td class="text-center"><span id="MontoAFa">{{previred.MontoAFa}}</span></td>
                                        <td class="text-center">Renta<span id="Primont">{{previred.Primont}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">2   (B)</td>
                                        <td class="text-center"><span id="MontoAFb">{{previred.MontoAFb}}</span></td>
                                        <td class="text-center">Renta > <span id="Primontb">{{previred.Primontb}}</span> <span id="Secmont">{{previred.Secmont}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">3   (C)</td>
                                        <td class="text-center"><span id="MontoAFc">{{previred.MontoAFc}}</span></td>
                                        <td class="text-center">Renta > <span id="Secmontb">{{previred.Secmontb}}</span>  <span id="Termont">{{previred.Termont}}</span></td>
                                    </tr>
                                    <tr>
                                        <td class="text-center">4   (D)</td>
                                        <td class="text-center"><span id="MontoAFd">{{previred.MontoAFd}}</span>---</td>
                                        <td class="text-center">Renta > <span id="Termontb">{{previred.Termontb}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table class="table table-striped table-sm table-bordered">
                                <thead style="background-color: #29235C;color: #fff;">
                                    <tr>
                                        <th colspan="4" class="text-center">Cotización para Trabajos Pesados</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-center">Calificación</th>
                                        <th colspan="2" class="text-center">Financiamiento</th>
                                    </tr>
                                    <tr>
                                        <th colspan="2" class="text-center">Puesto de Trabajo</th>
                                        <th class="text-center">Empleador</th>
                                        <th class="text-center">Trabajador</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="col-lg-8">Trabajo pesado</td>
                                        <td class="col-lg-4"><span id="Tpc">{{previred.Tpc}}</span></td>
                                        <td class="text-center"><span id="Tpe">{{previred.Tpe}}</span> R.I.</td>
                                        <td class="text-center"><span id="Tpt">{{previred.Tpt}}</span> R.I.</td>
                                    </tr>
                                    <tr>
                                        <td class="col-lg-8">Trabajo menos pesado</td>
                                        <td class="col-lg-4"><span id="Tmpc">{{previred.Tmpc}}</span></td>
                                        <td class="text-center"><span id="Tmpe">{{previred.Tmpe}}</span> R.I.</td>
                                        <td class="text-center"><span id="Tmpt">{{previred.Tmpt}}</span> R.I.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- End Chose Us -->
    <bannerFooter/>
  </div>
</template>

<script>

import bannerFooter from '../components/BannerFooter'
import axios from "axios"
import cons from '@/utils/const'

export default {
    name: "Contactanos",
    components: {
        bannerFooter
    },
    data () {
        return {
            fechaIndicador: "",
            previred: {
                "fechaUFactual": "-",
                "UFactual": "-",
                "fechaUFanterior": "-",
                "UFanterior": "-",
                "UTMfec": "-",
                "UTM": "-",
                "UTA": "-",
                "RTI1": "-",
                "PRTI1": "-",
                "RTI2": "-",
                "PRTI2": "-",
                "RTI3": "-",
                "PRTI3": "-",
                "RMI1": "-",
                "RMI2": "-",
                "RMI3": "-",
                "RMI4": "-",
                "APVtopeMensual": "-",
                "APVtopem": "-",
                "APVtopeAnual": "-",
                "APVtopea": "-",
                "DepoUF": "-",
                "DepoUFpesos": "-",
                "PIemp": "-",
                "PItra": "-",
                "PFemp": "-",
                "PFtra": "-",
                "PInemp": "-",
                "PIntra": "-",
                "Tcpemp": "-",
                "Tcptra": "-",
                "DTasaAFPCa": "-",
                "STasaAFPCa": "-",
                "ITasaAFPCa": "-",
                "DTasaAFPCu": "-",
                "STasaAFPCu": "-",
                "ITasaAFPCu": "-",
                "DTasaAFPH": "-",
                "STasaAFPH": "-",
                "ITasaAFPH": "-",
                "DTasaAFPPV": "-",
                "STasaAFPPV": "-",
                "ITasaAFPPV": "-",
                "DTasaAFPP": "-",
                "STasaAFPP": "-",
                "ITasaAFPP": "-",
                "DTasaAFPM": "-",
                "STasaAFPM": "-",
                "ITasaAFPM": "-",
                "DTasaAFPU": "-",
                "STasaAFPU": "-",
                "ITasaAFPU": "-",
                "MontoAFa": "-",
                "MontoAFb": "-",
                "MontoAFc": "-",
                "MontoAFd": "-",
                "Primont": "-",
                "Primontb": "-",
                "Secmont": "-",
                "Secmontb": "-",
                "Termont": "-",
                "Termontb": "-",
                "Tpc": "-",
                "Tpe": "-",
                "Tpt": "-",
                "Tmpc": "-",
                "Tmpe": "-",
                "Tmpt": "-"
            }
        }
    },
    beforeMount() {
        this.getIndicadores()
    },
  
    methods: {

        getIndicadores: function(){
            var d = new Date();
            var months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septimbre", "Octubre", "Novimbre", "Dicimbre"];
            var fechaTitulo = ""
            //var fechaApagar = ""
            var periodo = ""

            if(d.getDate()<20){
                if(d.getMonth()<10){
                    periodo = "0"+d.getMonth()+""+d.getFullYear()
                }
                else{
                    periodo = d.getMonth()+""+d.getFullYear()
                }
                fechaTitulo = months[d.getMonth()] + " " + d.getFullYear()
                //fechaApagar = months[d.getMonth()] + " " + d.getFullYear()
            }
            else{
                if(d.getMonth() == 0){
                    periodo = "01"+d.getFullYear()
                    fechaTitulo = months[0] + " " + d.getFullYear()
                    //fechaApagar = months[0] + " " + d.getFullYear()+1
                }
                else{
                    fechaTitulo = months[d.getMonth()] + " " + d.getFullYear()
                    if(d.getMonth()<10){
                        periodo = "0"+(d.getMonth()+1)+""+d.getFullYear()
                    }
                    else{

                        periodo = (d.getMonth()+1)+""+d.getFullYear()                     
                    }
                }
                
                //fechaApagar = months[d.getMonth()+1] + " " + d.getFullYear()
            }
            this.fechaIndicador = fechaTitulo
            //this.previred.cotAPagar = fechaApagar + " (Remuneraciones "+months[d.getMonth()] + " " + d.getFullYear() + ")"
            var url = `${cons.gaelApi}/previred/${periodo}`
            console.log(url)
            axios({
                method: "GET", 
                "url": url,
            }).then(result => {
                console.log(result)
                console.log(this.format(result.data.UFValPeriodo.replace(",","."),2))
                this.previred.fechaUFactual = (result.data.UFDescPeriodo)
                this.previred.UFactual = " $"+this.format(result.data.UFValPeriodo.replace(",","."),2)
                this.previred.fechaUFanterior = (result.data.UFDescPeridoAnt) 
                this.previred.UFanterior = " $"+this.format(result.data.UFValPeriodoAnt.replace(",","."),2)
                this.previred.UTMfec = (result.data.UTMDesc)
                this.previred.UTM = " $"+this.format(result.data.UTMVal.replace(",",".")) 
                this.previred.UTA = " $"+this.format(result.data.UTAVal.replace(",","."))
                this.previred.RTI1 = (result.data.RTIAfpUF)
                this.previred.PRTI1 = " $"+this.format(result.data.RTIAfpPesos.replace(",","."))
                this.previred.RTI2 = (result.data.RTIIpsUF)
                this.previred.PRTI2 = " $"+this.format(result.data.RTIIpsPesos.replace(",","."))
                this.previred.RTI3 = (result.data.RTISegCesUF)
                this.previred.PRTI3 = " $"+this.format(result.data.RTISegCesPesos.replace(",","."))
                this.previred.RMI1 = " $"+this.format(result.data.RMITrabDepeInd.replace(",","."))
                this.previred.RMI2 = " $"+this.format(result.data.RMIMen18May65.replace(",","."))
                this.previred.RMI3 = " $"+this.format(result.data.RMITrabCasaPart.replace(",","."))
                this.previred.RMI4 = " $"+this.format(result.data.RMINoRemu.replace(",","."))
                this.previred.APVtopeMensual = (result.data.APVTopeMensUF)
                this.previred.APVtopem = " $"+this.format(result.data.APVTopeMensPesos.replace(",","."))
                this.previred.APVtopeAnual = (result.data.APVTopeAnuUF)
                this.previred.APVtopea = " $"+this.format(result.data.APVTopeAnuPesos.replace(",","."))
                this.previred.DepoUF = (result.data.DepConvenidoUF)
                this.previred.DepoUFpesos = " $"+this.format(result.data.DepConvenidoPesos.replace(",","."))
                this.previred.PIemp = (result.data.AFCCpiEmpleador)+"%"
                this.previred.PItra = (result.data.AFCCpiTrabajador)+"%"
                this.previred.PFemp = (result.data.AFCCpfEmpleador)+"%"
                this.previred.PFtra = (result.data.AFCCpfTrabajador)
                this.previred.PInemp = (result.data.AFCCpi11Empleador)+"%"
                this.previred.PIntra = (result.data.AFCCpi11Trabajador)
                this.previred.Tcpemp = (result.data.AFCCpfEmpleador)+"%"
                this.previred.Tcptra = (result.data.AFCCpfTrabajador)
                const tasaSIS = result.data.TasaSIS
                this.previred.DTasaAFPCa = (result.data.AFPCapitalTasaDepTrab)+"%"
                this.previred.STasaAFPCa = tasaSIS+"%"
                this.previred.ITasaAFPCa = (result.data.AFPCapitalTasaInd)+"%"
                this.previred.DTasaAFPCu = (result.data.AFPCuprumTasaDepTrab)+"%"
                this.previred.STasaAFPCu = tasaSIS+"%"
                this.previred.ITasaAFPCu = (result.data.AFPCuprumTasaInd)+"%"
                this.previred.DTasaAFPH = (result.data.AFPHabitatTasaDepTrab)+"%"
                this.previred.STasaAFPH = tasaSIS+"%"
                this.previred.ITasaAFPH = (result.data.AFPHabitatTasaInd)+"%"
                this.previred.DTasaAFPPV = (result.data.AFPPlanVitalTasaDepTrab)+"%"
                this.previred.STasaAFPPV = tasaSIS+"%"
                this.previred.ITasaAFPPV = (result.data.AFPPlanVitalTasaInd)+"%"
                this.previred.DTasaAFPP = (result.data.AFPProVidaTasaDepTrab)+"%"
                this.previred.STasaAFPP = tasaSIS+"%"
                this.previred.ITasaAFPP = (result.data.AFPProVidaTasaInd)+"%"
                this.previred.DTasaAFPM = (result.data.AFPModeloTasaDepTrab)+"%"
                this.previred.STasaAFPM = tasaSIS+"%"
                this.previred.ITasaAFPM = (result.data.AFPModeloTasaInd)+"%"
                this.previred.DTasaAFPU = (result.data.AFPUnoTasaDepTrab)+"%"
                this.previred.STasaAFPU = tasaSIS+"%"
                this.previred.ITasaAFPU = (result.data.AFPUnoTasaInd)+"%"
                this.previred.MontoAFa = " $"+this.format(result.data.AFamTramoAMonto)
                this.previred.MontoAFb = " $"+this.format(result.data.AFamTramoBMonto) 
                this.previred.MontoAFc = " $"+this.format(result.data.AFamTramoCMonto) 
                this.previred.MontoAFd = (result.data.AFamTramoDMonto) 
                this.previred.Primont = " $"+this.format(result.data.AFamTramoAHasta)
                this.previred.Primontb = " $"+this.format(result.data.AFamTramoBDesde) 
                this.previred.Secmont = " $"+this.format(result.data.AFamTramoBHasta)
                this.previred.Secmontb = " $"+this.format(result.data.AFamTramoCDesde) 
                this.previred.Termont = " $"+this.format(result.data.AFamTramoCHasta)
                this.previred.Termontb = " $"+this.format(result.data.AFamTramoDDesde)
                this.previred.Tpc = (result.data.TrabPesadoCalif)+"%"
                this.previred.Tpe = (result.data.TrabPesadoEmpl)+"%"  
                this.previred.Tpt = (result.data.TrabPesadoTrabaj)+"%"  
                this.previred.Tmpc = (result.data.TrabMenosPesadoCalif)+"%"  
                this.previred.Tmpe = (result.data.TrabMenosPesadoEmpl)+"%"  
                this.previred.Tmpt = (result.data.TrabMenosPesadoTrabaj)+"%"

            }, error => {
              console.log(error)
                
            })
            .finally(() => {
                
            });
        },
        format: function(amount, decimals,separadorMiles,separadorDecimal) {
            var sepMiles = separadorMiles;
            var sepDecimal = separadorDecimal;
            if(typeof separadorMiles === "undefined"){
                sepMiles = ".";
            }
            if(typeof separadorDecimal === "undefined"){
                sepDecimal = ",";
            }
            amount += ''; // por si pasan un numero en vez de un string
            /* eslint-disable-next-line */
            amount = parseFloat(amount.replace(/[^0-9\.]/g, '')); // elimino cualquier cosa que no sea numero o punto
            decimals = decimals || 0; // por si la variable no fue fue pasada
            // si no es un numero o es igual a cero retorno el mismo cero
            if (isNaN(amount) || amount === 0) 
                return parseFloat(0).toFixed(decimals);
            // si es mayor o menor que cero retorno el valor formateado como numero
            amount = '' + amount.toFixed(decimals);
            var amount_parts = amount.split(sepMiles),
                regexp = /(\d+)(\d{3})/;
            while (regexp.test(amount_parts[0]))
                amount_parts[0] = amount_parts[0].replace(regexp, '$1' + sepMiles + '$2');
            return amount_parts.join(sepDecimal);
          }

    }
};
</script>

<style scope>

</style>